const getters = {
    getSupplierList(state){
        return state.supplierList;
    },
    getSupplier(state){
        return state.supplier;
    }
}

export default getters;